/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Progress_BodyInputs */

const en_features_progress_body = /** @type {(inputs: Features_Progress_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best sets, body measurements and diet week by week. You spot every new best before you think to ask.`)
};

const pl_features_progress_body = /** @type {(inputs: Features_Progress_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepsze serie, pomiary ciała i dieta tydzień po tygodniu. Każdy rekord zauważysz, zanim zdążysz o niego zapytać.`)
};

/**
* | output |
* | --- |
* | "Best sets, body measurements and diet week by week. You spot every new best before you think to ask." |
*
* @param {Features_Progress_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_progress_body = /** @type {((inputs?: Features_Progress_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Progress_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_progress_body(inputs)
	return en_features_progress_body(inputs)
});